import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {EtatService} from 'src/app/modules/services/etat-demande/etat.service';
import {AppTranslateService} from 'src/app/modules/services/translate/app-translate.service';
import {MatDialog} from '@angular/material/dialog';
import {ConfirmDialogService} from 'src/app/modules/services/ui/confirm-dialog.service';
import {SharedWsService} from '../../../../modules/services/Common/shared-ws.service';
import {ToastService} from '../../../../modules/toast/toast.service';

@Component({
    selector: 'app-detail-etat-acheteur',
    templateUrl: './detail-etat-acheteur.component.html',
    styleUrls: ['./detail-etat-acheteur.component.css']
})
export class DetailEtatAcheteurComponent implements OnInit {
    instRcvNo: any;
    public data_golb: any;

    constructor(
        private router: Router,
        public dialog: MatDialog,
        public confirmDialogService: ConfirmDialogService,
        private etatService: EtatService,
        private appTranslateService: AppTranslateService,
        private activatedRoute: ActivatedRoute,
        private sharedWs: SharedWsService,
        private toastService: ToastService
    ) {
        this.activatedRoute.params.subscribe((params) => {

            this.instRcvNo = params.instRcvNo;


        });
    }

    ngOnInit(): void {
        this.getGlobInfo();
    }


    getGlobInfo() {
        const body = {

            'dataSearch': [
                {
                    'key': 'instRcvNo',
                    'value': this.instRcvNo,
                    'specificSearch': '='
                }
            ]
        };

        this.etatService
            .loadDetailEtatAcheteur(body)
            .subscribe((response) => {

                this.data_golb = response['payload']['data'][0];
            });

    }

    getlang() {
        return this.appTranslateService.getDefaultLang();
    }


    /* AnnulerDemandeAcheteur(){
      const dialogRef = this.dialog.open(AnnulerDemandeAchComponent, {
        width: '600px',
        disableClose: true,
        direction: this.appTranslateService.getDir(),
        data: {
          instRcvNo:this.instRcvNo,


        }
      });

      dialogRef.afterClosed().subscribe(result => {


      });

    } */

    AnnulerDemandeAcheteur() {
        this.confirmDialogService.confirm('', 'Voulez-vous annuler l\'enregistrement de l\'acheteur public ?').subscribe((flag) => {

            if (flag) {

                this.etatService
                    .AnnulEtatAcheteur(this.instRcvNo)
                    .subscribe((response) => {



                        if (response['code'] == '200') {
                            this.router.navigate(['/portail/acheteur']);
                        }
                    });


            }

        });

    }
}
